<template>
  <div class="not-login-bottom" v-if="!isLogin">
    <div class="login-wrap">
      <div class="login-info">
        <div class="login-title">{{ letter.v3LoginToViewOffers }}</div>
        <div class="login-desc">
          <Icon class="login-icon" name="people-safe" />
          <span> {{ letter.v3SafeToUse }}</span>
        </div>
      </div>
      <div
        class="login-btn j-login-btn flex-center"
        @click="handleShowLoginPopup"
      >
        <span class="login-btn-text">
          {{ letter.v3Login }}
        </span>
      </div>
    </div>
    <div class="discount-info">
      <img class="discount-logo" v-if="logo" :src="logo" alt="discount-logo" />
      <div class="discount-content">
        <p class="discount-title">
          {{ letter.v3FirstTopUp15PercentOff }}
        </p>
        <p class="discount-desc">{{ letter.v3MoreTopUpRebates }}</p>
      </div>
      <div @click="handleShowLoginPopup">
        <Icon class="discount-btn" name="right" />
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapState } from 'vuex';
import globalConfig from '@utiles/officialStore/globalConfig';
import { locationType, clickButton } from '@plugins/biPoint/_configWebstoreV3';
import login from '@mixins/officialTopup/login';
export default {
  mixins: [login],
  data() {
    return {
      showLangSelecter: false
    };
  },
  computed: {
    ...mapState({
      letter: state => state.letter,
      lang: state => state.lang,
      gameId: state => state.gameId,
      picList: state => state.page.picList
    }),
    ...mapGetters(['getCoinsName', 'isJpPlatform']),
    logo() {
      return this.picList?.payDiscount;
    }
  },
  methods: {
    backToHome() {
      if (this.$route.name === 'home') return;
      this.$router.push({
        name: 'home'
      });
    },
    toggleLangSelecter() {
      clickButton({
        btnName: 'select_language_btn',
        locationKey: this.$route.meta.pageName
      });
      this.showLangSelecter = !this.showLangSelecter;
    },
    handleShowLoginPopup() {
      clickButton({
        btnName: 'go_login',
        locationKey: locationType.accountInfo
      });
      this.showLoginPopup();
    }
  },
  components: {}
};
</script>

<style lang="scss" scoped>
@import '@assets/scss/officialTopup/_dimen.scss';
.not-login-bottom {
  position: sticky;
  width: 100%;
  bottom: 0;
  background-color: #ffffff;
  z-index: 9;

  .login-wrap {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 30px 40px;
    border-bottom: 1px solid #f4f4f4;

    .login-info {
      .login-title {
        font-weight: bold;
        font-size: 24px;
        color: #333333;
      }
      .login-desc {
        margin-top: 10px;
        display: flex;
        align-items: center;
        font-size: 20px;
        color: #999999;
      }
      .login-icon {
        width: 24px;
        height: 24px;
      }
    }
    .login-btn {
      margin-left: 10px;
      color: #ffffff;
      font-size: 24px;
      min-width: 176px;
      min-height: 39px;
      padding: 10px 20px;
      background-color: $themeColor;
      border-radius: 9px;
      cursor: pointer;
    }
  }

  .discount-info {
    position: relative;
    display: flex;
    align-items: center;
    padding: 30px 40px;
    .discount-logo {
      height: 51px;
    }
    .discount-content {
      margin-left: 20px;
      line-height: 1.1;
      .discount-title {
        font-weight: bold;
        font-size: 26px;
        color: #333333;
      }
      .discount-desc {
        font-size: 25px;
        color: #666666;
      }
    }
    .discount-btn {
      position: absolute;
      top: 50%;
      right: 40px;
      transform: translateY(-50%);
      width: 40px;
      height: 40px;
    }
  }
}

@media screen and (orientation: landscape) {
  .not-login-bottom {
    display: none;
  }
}
</style>
